import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
import { provideRouter } from '@angular/router';
 
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
 
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GoogleMapsModule } from '@angular/google-maps';
import { AppConfig } from './app/app.config';
import { APP_INITIALIZER } from '@angular/core';
 
import { routes } from './app/app.routes';
import 'zone.js';
 
export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load();
}
 
if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(),
    provideRouter(routes),
    AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig],
      multi: true
    },
    importProvidersFrom(
      NgbModule,
      GoogleMapsModule
    )
  ]
}).catch(err => console.error(err));
